import { render, staticRenderFns } from "./CommentList.vue?vue&type=template&id=524d68e6&scoped=true&lang=pug&"
import script from "./CommentList.vue?vue&type=script&lang=js&"
export * from "./CommentList.vue?vue&type=script&lang=js&"
import style0 from "./CommentList.scss?vue&type=style&index=0&id=524d68e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524d68e6",
  null
  
)

export default component.exports